import Roof from "globalConstants/Icons/Roof";

const Orientation = {
  lengthwise: ({ state }) => <Roof.roofSlope state={state} end tick={false}/>,
  // eslint-disable-next-line
  widewise: ({ state }) => <Roof.roofSlope state={state} vertical end tick={false}/>,
  // eslint-disable-next-line
};

export default Orientation;